import api from 'app/api';
import addDocument from './add-document';
import deleteDocument from './delete-document';
import getDocument from './get-document';

export const documentsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        addDocument: addDocument(builder),
        getDocument: getDocument(builder),
        deleteDocument: deleteDocument(builder),
    }),
});

export const { useAddDocumentMutation, useDeleteDocumentMutation, useGetDocumentQuery, useLazyGetDocumentQuery } =
    documentsApi;
